// @ts-nocheck

import { ToastrTypes } from '../../types/toastr';
import palette from '../palette';

export const ZIndices = {
  /* out app */
  // websiteHeader: 13,
  // websiteContainer: 5,
  // websiteFooter: 0,
  // websiteMobilPanel: 14,
  /* in app */
  basketHeader: 10,
  matchBetFilters: 10,
  middleColumn: 11,
  floatingVideo: 12,
  floatingWtv: 12,
  trackerAndStream: 15,
  mobileBars: 20,
  floatingMyMatchErrorPopUp: 23,
  scrollTopFloatingButton: 25,
  searchResultsDesktop: 50,
  tabBar: 101,
  navBar: 101,
  lineUpModal: 110,
  overlay: 115,
  floatingBasketButton: 120,
  oddsTravelAnimation: 121,
  basket: 130,
  betslipModal: 131,
  betShare: 135,
  missionsDetailsModal: 135,
  shareSettingsModal: 136,
  floatingToolTip: 137,
  modal: 140,
  winModal: 140,
  loginModal: 150,
  userAccountModal: 150,
  gridTutoModal: 150,
  gridTutoModalNavBar: 151,
  graphicalPreferencesModal: 155,
  klnotifs: 150,
  mobileMenu: 160,
  tooltip: 200,
  toastr: 300,

  floatingVideoPip: 999999,
};

export const Card = {
  borderRadius: '1rem',
};

export const Toastr = {
  [ToastrTypes.SUCCESS]: { color: palette.white, backgroundColor: palette.greenwinamax450 },
  [ToastrTypes.ERROR]: { color: palette.white, backgroundColor: palette.red100 },
  [ToastrTypes.INFO]: { color: palette.white, backgroundColor: palette.bluepastel },
  FALLBACK: { color: palette.white, backgroundColor: palette.bluepastel },
};

export const Switch = {
  Default: {
    toggled: {
      mainBackgroundColor: palette.greenwinamax450,
      borderBackgroundColor: palette.white,
      circleBackgroundColor: palette.white,
      circleColor: palette.bluegrey850,
    },
    untoggled: {
      mainBackgroundColor: palette.bluegrey700,
      borderBackgroundColor: palette.neutralgrey350,
      circleBackgroundColor: palette.neutralgrey200,
      circleColor: palette.bluegrey850,
    },
    labelColor: palette.neutralgrey200,
    labelBackgroundColor: palette.transparent,
  },
};

export const App = {
  backgroundColor: palette.black,
};

export const TVBar = {
  backgroundColor: palette.bluegrey850,
  borderColor: palette.red200,
  textColor: palette.white,
};

export const Checkbox = {
  SystemBaseCheckbox: {
    checkboxBorderColor: palette.neutralgrey450,
    checkmarkColor: palette.white,
    labelColor: palette.neutralgrey200,
  },
};

export const CommonListItem = {
  textColor: {
    default: palette.white,
  },
  odd: {
    backgroundColor: palette.listitemodd,
  },
  even: {
    backgroundColor: palette.listitemeven,
  },
};

export const Breadcrumbs = {
  backgroundColor: palette.bluegrey950,
  color: palette.white,
  svgColor: palette.white,
};

export const NotFoundView = {
  Icon: {
    borderColor: palette.red200,
  },
  Label: {
    color: palette.white,
  },
  SubLabel: {
    color: palette.neutralgrey450,
  },
  TopMatchButton: {
    backgroundColor: palette.red200,
    color: palette.white,
  },
};

export const BasketEmptyView = {
  SubLabel: {
    color: palette.neutralgrey200,
  },
  Label: {
    color: palette.white,
  },
};

export const WinaLoader = {
  backgroundColor: palette.bluegrey925,
  innerBorderColor: palette.red200,
  outerBorderColor: palette.bluegrey800,
};

export const Counter = {
  none: {
    backgroundColor: palette.neutralgrey800,
    color: palette.neutralgrey350,
  },
  some: {
    backgroundColor: palette.white,
    color: palette.black,
  },
};

export const Promotions = {
  color: palette.white,
};

export const PrimaryButton = {
  disabled: {
    color: palette.neutralgrey550,
    backgroundColor: palette.bluegrey750,
  },
  default: {
    color: palette.white,
    backgroundColor: palette.red200,
  },
};

export const LongPressButton = {
  default: {
    color: palette.white,
    backgroundColor: palette.neutralgrey550,
    fillBackgroundColor: palette.red650,
  },
};

export const AffiliationButton = {
  borderGradient: palette.affiliationbuttonborder,
  backgroundGradient: palette.affiliationbuttonbackground,
  detailButtonBackground: palette.bluegrey700,
  labelColor: palette.neutralgrey200,
};

export const TMMArrowButton = {
  default: {
    backgroundColor: palette.bluegrey750,
    color: palette.white,
  },
  disabled: {
    backgroundColor: palette.bluegrey850,
    color: palette.neutralgrey550,
  },
  hover: {
    backgroundColor: palette.bluegrey400,
    color: palette.white,
  },
};

export const Tabs = {
  default: {
    backgroundColor: palette.bluegrey800,
    color: palette.neutralgrey200,
    circleBackgroundColor: palette.transparent,
  },
  selected: {
    backgroundColor: palette.bluegrey700,
    color: palette.white,
    circleBackgroundColor: palette.red200,
  },
};

export const DefaultTabs = {
  default: {
    backgroundColor: palette.bluegrey900,
    color: palette.bluegrey400,
  },
  selected: {
    backgroundColor: palette.bluegrey800,
    color: palette.white,
  },
};

export const InfosLabel = {
  infosGrey: {
    backgroundColor: palette.bluegrey800,
    color: palette.neutralgrey200,
    symbolBackgroundColor: palette.neutralgrey200,
  },
  infosBlue: {
    backgroundColor: palette.blueinfo800,
    color: palette.blueinfo200,
    symbolBackgroundColor: palette.blueinfo350,
  },
  infosYellow: {
    backgroundColor: palette.yellowinfo900,
    color: palette.yellowinfo200,
    symbolBackgroundColor: palette.yellowwinamax350,
  },
  infosRed: {
    backgroundColor: palette.redinfo900,
    color: palette.redinfo200,
    symbolBackgroundColor: palette.redwinamax350,
  },
};

export const FloatingTooltip = {
  backgroundColor: palette.blueinfo900,
  color: palette.blueinfo200,
};

export const Slider = {
  default: {
    cursorColor: palette.white,
    leftBarColor: palette.white,
    rightBarColor: palette.bluegrey700,
    anchorColor: palette.neutralgrey950,
    tooltipBackgroundColor: palette.black,
    tooltipColor: palette.white,
    tooltipBorderColor: palette.white,
  },
  disabled: {
    cursorColor: palette.bluegrey800,
    leftBarColor: palette.bluegrey800,
    rightBarColor: palette.bluegrey800,
    anchorColor: palette.neutralgrey950,
    tooltipBackgroundColor: palette.black,
    tooltipColor: palette.white,
    tooltipBorderColor: palette.white,
  },
};

export const RoundedButton = {
  secondaryButtonBackgroundColor: palette.bluegrey800,
  bonusTitle: palette.white,
  iconButtonColor: palette.white,
};
